import { AxiosInstance } from 'axios'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { LOGOUT, UserActions, LOGIN } from './actions'
import { loginUser, logoutUser } from '../../api/user'
import { LOGIN as LOGIN_PATH } from '../../routes'
import { SessionActions } from '../session/actions'

export const setAuthorizationHeader = (axiosInstance: AxiosInstance, token: string) => {
  // eslint-disable-next-line no-param-reassign
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`
}

// function* processToken(data: LoginResponse) {
//   if (!data) return
//   yield call(setAuthorizationHeader, axios, data.token)
//   yield put(UserActions.setToken(data.token, data.role))
// }

export function* login(action: ReturnType<typeof UserActions.login>) {
  const { email, password } = action.payload
  try {
    const response = yield call(loginUser, email, password)
    yield put(SessionActions.setSession(response.data))
  } catch (err) {
    const status = err.response && err.response.status
    const msg = status === 401 ? 'LoginErrorMessage' : 'error:ServerError'
    // eslint-disable-next-line no-console
    yield console.log(msg)
  }
}
export function* logout(action: ReturnType<typeof UserActions.logout>) {
  const { sessionId } = action.payload

  yield call(logoutUser, sessionId)
  yield put(SessionActions.clearSession())
  // yield call(setAuthorizationHeader, axios, '')
  yield put(push(LOGIN_PATH))
}

export function* rootSaga() {
  yield all([takeLatest(LOGIN, login), takeLatest(LOGOUT, logout)])
}
